/* @generated */
const FOUNDATION_COLOR_TOKENS = {
  "Foundation Gold 50": "#f9f6f0",
  "Foundation Gold 100": "#f1e8d8",
  "Foundation Gold 150": "#eadabd",
  "Foundation Gold 200": "#e4cd9f",
  "Foundation Gold 250": "#dfbd7d",
  "Foundation Gold 300": "#dcaf57",
  "Foundation Gold 350": "#dc9e29",
  "Foundation Gold 400": "#ce911e",
  "Foundation Gold 450": "#bf8519",
  "Foundation Gold 500": "#b17914",
  "Foundation Gold 550": "#a26f10",
  "Foundation Gold 600": "#93640c",
  "Foundation Gold 650": "#845909",
  "Foundation Gold 700": "#764f07",
  "Foundation Gold 750": "#684505",
  "Foundation Gold 800": "#593a03",
  "Foundation Gold 850": "#4c3102",
  "Foundation Gold 900": "#3e2801",
  "Foundation Gold 950": "#311f00",
  "Foundation Gold 1000": "#241700",
  "Foundation Gold Base": "#9b6400",
  "Foundation Azalea 50": "#fcf4f8",
  "Foundation Azalea 100": "#f8e4ee",
  "Foundation Azalea 150": "#f3d3e3",
  "Foundation Azalea 200": "#efc2d9",
  "Foundation Azalea 250": "#ebb2ce",
  "Foundation Azalea 300": "#e6a1c3",
  "Foundation Azalea 350": "#e28fb9",
  "Foundation Azalea 400": "#de7eae",
  "Foundation Azalea 450": "#da6ba2",
  "Foundation Azalea 500": "#d55796",
  "Foundation Azalea 550": "#d04188",
  "Foundation Azalea 600": "#c3307a",
  "Foundation Azalea 650": "#b02b6d",
  "Foundation Azalea 700": "#9d2561",
  "Foundation Azalea 750": "#892055",
  "Foundation Azalea 800": "#771c4a",
  "Foundation Azalea 850": "#66173f",
  "Foundation Azalea 900": "#531333",
  "Foundation Azalea 950": "#410f28",
  "Foundation Azalea 1000": "#310b1e",
  "Foundation Azalea Base": "#cd2f7b",
  "Foundation Plum 50": "#f9f5f8",
  "Foundation Plum 100": "#f1e6ee",
  "Foundation Plum 150": "#e8d6e4",
  "Foundation Plum 200": "#e1c8db",
  "Foundation Plum 250": "#d9b9d2",
  "Foundation Plum 300": "#d2a9c9",
  "Foundation Plum 350": "#cc99c1",
  "Foundation Plum 400": "#c689ba",
  "Foundation Plum 450": "#bf78b2",
  "Foundation Plum 500": "#ba67ab",
  "Foundation Plum 550": "#b456a3",
  "Foundation Plum 600": "#a74898",
  "Foundation Plum 650": "#983f8a",
  "Foundation Plum 700": "#89367c",
  "Foundation Plum 750": "#792e6e",
  "Foundation Plum 800": "#682760",
  "Foundation Plum 850": "#592051",
  "Foundation Plum 900": "#491944",
  "Foundation Plum 950": "#3a1336",
  "Foundation Plum 1000": "#2b0e28",
  "Foundation Plum Base": "#78286e",
  "Foundation Navy 50": "#f6f6f7",
  "Foundation Navy 100": "#e8e9ec",
  "Foundation Navy 150": "#dbdce1",
  "Foundation Navy 200": "#ceced7",
  "Foundation Navy 250": "#c0c1cd",
  "Foundation Navy 300": "#b3b4c4",
  "Foundation Navy 350": "#a5a8bb",
  "Foundation Navy 400": "#979cb3",
  "Foundation Navy 450": "#8a90ac",
  "Foundation Navy 500": "#7c83a4",
  "Foundation Navy 550": "#6e789d",
  "Foundation Navy 600": "#606c93",
  "Foundation Navy 650": "#556085",
  "Foundation Navy 700": "#4a5678",
  "Foundation Navy 750": "#3f4c6a",
  "Foundation Navy 800": "#35415c",
  "Foundation Navy 850": "#2b374d",
  "Foundation Navy 900": "#222d40",
  "Foundation Navy 950": "#1b2433",
  "Foundation Navy 1000": "#131a25",
  "Foundation Navy Base": "#283750",
  "Foundation Canopy 50": "#f4f7f6",
  "Foundation Canopy 100": "#e2ece8",
  "Foundation Canopy 150": "#cfe0da",
  "Foundation Canopy 200": "#b8d6cc",
  "Foundation Canopy 250": "#9fcbbd",
  "Foundation Canopy 300": "#83c3ad",
  "Foundation Canopy 350": "#60ba9c",
  "Foundation Canopy 400": "#45ae8b",
  "Foundation Canopy 450": "#3ca280",
  "Foundation Canopy 500": "#349574",
  "Foundation Canopy 550": "#2c8769",
  "Foundation Canopy 600": "#267b5e",
  "Foundation Canopy 650": "#206f54",
  "Foundation Canopy 700": "#1b634b",
  "Foundation Canopy 750": "#175641",
  "Foundation Canopy 800": "#124b38",
  "Foundation Canopy 850": "#0f3f2f",
  "Foundation Canopy 900": "#0b3326",
  "Foundation Canopy 950": "#09291e",
  "Foundation Canopy 1000": "#061e16",
  "Foundation Canopy Base": "#0f503c",
  "Foundation Rust 50": "#fbf5f2",
  "Foundation Rust 100": "#f6e6de",
  "Foundation Rust 150": "#f0d7c9",
  "Foundation Rust 200": "#ecc8b5",
  "Foundation Rust 250": "#e8b79e",
  "Foundation Rust 300": "#e5a887",
  "Foundation Rust 350": "#e29770",
  "Foundation Rust 400": "#e08555",
  "Foundation Rust 450": "#de7338",
  "Foundation Rust 500": "#d86120",
  "Foundation Rust 550": "#c5581b",
  "Foundation Rust 600": "#b44f16",
  "Foundation Rust 650": "#a14612",
  "Foundation Rust 700": "#903e0e",
  "Foundation Rust 750": "#7f360b",
  "Foundation Rust 800": "#6d2e09",
  "Foundation Rust 850": "#5e2707",
  "Foundation Rust 900": "#4d1f05",
  "Foundation Rust 950": "#3d1803",
  "Foundation Rust 1000": "#2d1202",
  "Foundation Rust Base": "#be4b0a",
  "Foundation Crimson 50": "#fbf5f7",
  "Foundation Crimson 100": "#f5e5eb",
  "Foundation Crimson 150": "#f1d6de",
  "Foundation Crimson 200": "#ecc5d2",
  "Foundation Crimson 250": "#e9b5c6",
  "Foundation Crimson 300": "#e5a3b9",
  "Foundation Crimson 350": "#e392ac",
  "Foundation Crimson 400": "#e17f9f",
  "Foundation Crimson 450": "#df6a91",
  "Foundation Crimson 500": "#de5380",
  "Foundation Crimson 550": "#de346b",
  "Foundation Crimson 600": "#d21c57",
  "Foundation Crimson 650": "#c0154c",
  "Foundation Crimson 700": "#ab1042",
  "Foundation Crimson 750": "#970b38",
  "Foundation Crimson 800": "#85072f",
  "Foundation Crimson 850": "#720427",
  "Foundation Crimson 900": "#600220",
  "Foundation Crimson 950": "#4e0119",
  "Foundation Crimson 1000": "#3c0013",
  "Foundation Crimson Base": "#9b0032",
  "Foundation Ocean 50": "#f1f8f9",
  "Foundation Ocean 100": "#d9eef0",
  "Foundation Ocean 150": "#bde3e9",
  "Foundation Ocean 200": "#a0d9e2",
  "Foundation Ocean 250": "#7bd0dd",
  "Foundation Ocean 300": "#4cc6da",
  "Foundation Ocean 350": "#22b9d3",
  "Foundation Ocean 400": "#1cacc5",
  "Foundation Ocean 450": "#179eb7",
  "Foundation Ocean 500": "#1392a9",
  "Foundation Ocean 550": "#0f849a",
  "Foundation Ocean 600": "#0c778c",
  "Foundation Ocean 650": "#096b7e",
  "Foundation Ocean 700": "#075f71",
  "Foundation Ocean 750": "#055463",
  "Foundation Ocean 800": "#034855",
  "Foundation Ocean 850": "#023d48",
  "Foundation Ocean 900": "#01323b",
  "Foundation Ocean 950": "#002730",
  "Foundation Ocean 1000": "#001d23",
  "Foundation Ocean Base": "#007891",
  "Foundation Vivid Vargas 50": "#fef6dc",
  "Foundation Vivid Vargas 100": "#fbe8ae",
  "Foundation Vivid Vargas 150": "#f5db84",
  "Foundation Vivid Vargas 200": "#eecc5d",
  "Foundation Vivid Vargas 250": "#e6bd3b",
  "Foundation Vivid Vargas 300": "#dcaf21",
  "Foundation Vivid Vargas 350": "#cca421",
  "Foundation Vivid Vargas 400": "#bd9820",
  "Foundation Vivid Vargas 450": "#ae8c1f",
  "Foundation Vivid Vargas 500": "#9f811e",
  "Foundation Vivid Vargas 550": "#91761d",
  "Foundation Vivid Vargas 600": "#836b1c",
  "Foundation Vivid Vargas 650": "#755f1a",
  "Foundation Vivid Vargas 700": "#675418",
  "Foundation Vivid Vargas 750": "#5a4a16",
  "Foundation Vivid Vargas 800": "#4d3f14",
  "Foundation Vivid Vargas 850": "#413511",
  "Foundation Vivid Vargas 900": "#352b0f",
  "Foundation Vivid Vargas 950": "#2a220c",
  "Foundation Vivid Vargas 1000": "#1e1909",
  "Foundation Vivid Vargas Base": "#fad24b",
  "Foundation Pink 50": "#fff4f3",
  "Foundation Pink 100": "#fee3e1",
  "Foundation Pink 150": "#fdd2cf",
  "Foundation Pink 200": "#fbc2bc",
  "Foundation Pink 250": "#f8b0aa",
  "Foundation Pink 300": "#f49f97",
  "Foundation Pink 350": "#f08e85",
  "Foundation Pink 400": "#e97e73",
  "Foundation Pink 450": "#e26d62",
  "Foundation Pink 500": "#d95e52",
  "Foundation Pink 550": "#ce4e42",
  "Foundation Pink 600": "#bd4438",
  "Foundation Pink 650": "#a64137",
  "Foundation Pink 700": "#8f3d35",
  "Foundation Pink 750": "#783932",
  "Foundation Pink 800": "#64332e",
  "Foundation Pink 850": "#512d29",
  "Foundation Pink 900": "#3f2623",
  "Foundation Pink 950": "#2f1e1d",
  "Foundation Pink 1000": "#211716",
  "Foundation Pink Base": "#ffafa5",
  "Foundation Orchid 50": "#f8f5fd",
  "Foundation Orchid 100": "#ede6f9",
  "Foundation Orchid 150": "#e3d7f6",
  "Foundation Orchid 200": "#d8c8f1",
  "Foundation Orchid 250": "#ccb9ec",
  "Foundation Orchid 300": "#c1ace7",
  "Foundation Orchid 350": "#b69de1",
  "Foundation Orchid 400": "#ab90db",
  "Foundation Orchid 450": "#9f82d4",
  "Foundation Orchid 500": "#9474cc",
  "Foundation Orchid 550": "#8867c4",
  "Foundation Orchid 600": "#7c5aba",
  "Foundation Orchid 650": "#714eb1",
  "Foundation Orchid 700": "#624894",
  "Foundation Orchid 750": "#55417b",
  "Foundation Orchid 800": "#483a65",
  "Foundation Orchid 850": "#3c3151",
  "Foundation Orchid 900": "#30293f",
  "Foundation Orchid 950": "#25202f",
  "Foundation Orchid 1000": "#1b1821",
  "Foundation Orchid Base": "#c8aff0",
  "Foundation Cloud 50": "#f4f7fa",
  "Foundation Cloud 100": "#e3ebf2",
  "Foundation Cloud 150": "#d2dee9",
  "Foundation Cloud 200": "#c2d1e1",
  "Foundation Cloud 250": "#b2c4d7",
  "Foundation Cloud 300": "#a3b8ce",
  "Foundation Cloud 350": "#94acc3",
  "Foundation Cloud 400": "#86a0ba",
  "Foundation Cloud 450": "#7894af",
  "Foundation Cloud 500": "#6a88a5",
  "Foundation Cloud 550": "#5f7b98",
  "Foundation Cloud 600": "#576f88",
  "Foundation Cloud 650": "#506478",
  "Foundation Cloud 700": "#485969",
  "Foundation Cloud 750": "#404d5b",
  "Foundation Cloud 800": "#38434d",
  "Foundation Cloud 850": "#2f3740",
  "Foundation Cloud 900": "#272d34",
  "Foundation Cloud 950": "#1f2428",
  "Foundation Cloud 1000": "#171a1d",
  "Foundation Cloud Base": "#b4c8e1",
  "Foundation Lime 50": "#f3fadc",
  "Foundation Lime 100": "#dff29f",
  "Foundation Lime 150": "#caea5b",
  "Foundation Lime 200": "#b4df1c",
  "Foundation Lime 250": "#aad11a",
  "Foundation Lime 300": "#9fc418",
  "Foundation Lime 350": "#93b516",
  "Foundation Lime 400": "#89a914",
  "Foundation Lime 450": "#7f9b12",
  "Foundation Lime 500": "#748e11",
  "Foundation Lime 550": "#6a830f",
  "Foundation Lime 600": "#60750e",
  "Foundation Lime 650": "#56690c",
  "Foundation Lime 700": "#4c5d0b",
  "Foundation Lime 750": "#435109",
  "Foundation Lime 800": "#3a4608",
  "Foundation Lime 850": "#313c07",
  "Foundation Lime 900": "#283105",
  "Foundation Lime 950": "#1f2604",
  "Foundation Lime 1000": "#171c03",
  "Foundation Lime Base": "#b4dc19",
  "Foundation Tangerine 50": "#fff5eb",
  "Foundation Tangerine 100": "#ffe5cc",
  "Foundation Tangerine 150": "#fed5ac",
  "Foundation Tangerine 200": "#fdc58c",
  "Foundation Tangerine 250": "#fbb36b",
  "Foundation Tangerine 300": "#f9a34b",
  "Foundation Tangerine 350": "#f69129",
  "Foundation Tangerine 400": "#ef800c",
  "Foundation Tangerine 450": "#dc760c",
  "Foundation Tangerine 500": "#c96d0c",
  "Foundation Tangerine 550": "#b7630c",
  "Foundation Tangerine 600": "#a65a0c",
  "Foundation Tangerine 650": "#94510b",
  "Foundation Tangerine 700": "#82480a",
  "Foundation Tangerine 750": "#723f09",
  "Foundation Tangerine 800": "#623609",
  "Foundation Tangerine 850": "#522e07",
  "Foundation Tangerine 900": "#432606",
  "Foundation Tangerine 950": "#351e05",
  "Foundation Tangerine 1000": "#271604",
  "Foundation Tangerine Base": "#ff8c19",
  "Foundation Sunset 50": "#fff4f1",
  "Foundation Sunset 100": "#ffe4dc",
  "Foundation Sunset 150": "#fed3c6",
  "Foundation Sunset 200": "#fec0af",
  "Foundation Sunset 250": "#fdaf9a",
  "Foundation Sunset 300": "#fb9d83",
  "Foundation Sunset 350": "#f98a6b",
  "Foundation Sunset 400": "#f77751",
  "Foundation Sunset 450": "#f46135",
  "Foundation Sunset 500": "#f04715",
  "Foundation Sunset 550": "#dd3f10",
  "Foundation Sunset 600": "#c83a0f",
  "Foundation Sunset 650": "#b3350f",
  "Foundation Sunset 700": "#9d300e",
  "Foundation Sunset 750": "#892b0d",
  "Foundation Sunset 800": "#76260c",
  "Foundation Sunset 850": "#63200b",
  "Foundation Sunset 900": "#511b09",
  "Foundation Sunset 950": "#401608",
  "Foundation Sunset 1000": "#2f1006",
  "Foundation Sunset Base": "#fa551e",
  "Foundation Zen 50": "#e8fafd",
  "Foundation Zen 100": "#c1f2fa",
  "Foundation Zen 150": "#99e8f6",
  "Foundation Zen 200": "#6edff2",
  "Foundation Zen 250": "#3dd3ee",
  "Foundation Zen 300": "#14c6e7",
  "Foundation Zen 350": "#13b9d7",
  "Foundation Zen 400": "#12acc8",
  "Foundation Zen 450": "#109eb8",
  "Foundation Zen 500": "#0f92aa",
  "Foundation Zen 550": "#0e849a",
  "Foundation Zen 600": "#0c788b",
  "Foundation Zen 650": "#0b6c7d",
  "Foundation Zen 700": "#0a6070",
  "Foundation Zen 750": "#095462",
  "Foundation Zen 800": "#074854",
  "Foundation Zen 850": "#063c47",
  "Foundation Zen 900": "#05313a",
  "Foundation Zen 950": "#04282e",
  "Foundation Zen 1000": "#031d22",
  "Foundation Zen Base": "#14c8eb",
  "Foundation Gray 50": "#f7f6f5",
  "Foundation Gray 100": "#ebe9e6",
  "Foundation Gray 150": "#dfdcd8",
  "Foundation Gray 200": "#d3cec9",
  "Foundation Gray 250": "#c7c1bb",
  "Foundation Gray 300": "#bbb5ae",
  "Foundation Gray 350": "#afa8a0",
  "Foundation Gray 400": "#a49b93",
  "Foundation Gray 450": "#978f86",
  "Foundation Gray 500": "#8c8279",
  "Foundation Gray 550": "#7f776f",
  "Foundation Gray 600": "#736c64",
  "Foundation Gray 650": "#67615a",
  "Foundation Gray 700": "#5b5650",
  "Foundation Gray 750": "#4f4a46",
  "Foundation Gray 800": "#44403d",
  "Foundation Gray 850": "#393633",
  "Foundation Gray 900": "#2d2b29",
  "Foundation Gray 950": "#242321",
  "Foundation Gray 1000": "#1a1918",
  "Foundation Gray Base": "#d9d4cc",
  "Foundation Brand Graphite": "#1e1919",
  "Foundation Brand Coconut": "#f7f5f2",
  "Foundation Dropbox Bluenight": "#3984ff",
  "Foundation Dropbox Blue 50": "#f2f7ff",
  "Foundation Dropbox Blue 100": "#deebff",
  "Foundation Dropbox Blue 150": "#c9ddff",
  "Foundation Dropbox Blue 200": "#b4d1ff",
  "Foundation Dropbox Blue 250": "#a0c4ff",
  "Foundation Dropbox Blue 300": "#8bb7ff",
  "Foundation Dropbox Blue 350": "#75aaff",
  "Foundation Dropbox Blue 400": "#5f9dff",
  "Foundation Dropbox Blue 450": "#488eff",
  "Foundation Dropbox Blue 500": "#3080ff",
  "Foundation Dropbox Blue 550": "#1770ff",
  "Foundation Dropbox Blue 600": "#0061fa",
  "Foundation Dropbox Blue 650": "#0057e0",
  "Foundation Dropbox Blue 700": "#004dc7",
  "Foundation Dropbox Blue 750": "#0044af",
  "Foundation Dropbox Blue 800": "#003a97",
  "Foundation Dropbox Blue 850": "#003280",
  "Foundation Dropbox Blue 900": "#002969",
  "Foundation Dropbox Blue 950": "#002053",
  "Foundation Dropbox Blue 1000": "#00183e",
  "Foundation Dropbox Blue Base": "#0061fe",
  "Foundation Anchor Black": "#000000",
  "Foundation Anchor White": "#ffffff"
};
export {
  FOUNDATION_COLOR_TOKENS
};
